"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DactylAndIda = void 0;
var Tags_1 = require("../../Tags");
var Card_1 = require("../../Card");
var CardType_1 = require("../../CardType");
var CardName_1 = require("../../../CardName");
var constants_1 = require("../../../constants");
var PartyHooks_1 = require("../../../turmoil/parties/PartyHooks");
var PartyName_1 = require("../../../turmoil/parties/PartyName");
var CardRenderer_1 = require("../../render/CardRenderer");
var ResourceType_1 = require("../../../ResourceType");
var SelectCard_1 = require("../../../inputs/SelectCard");
var DactylAndIda = (function (_super) {
    __extends(DactylAndIda, _super);
    function DactylAndIda() {
        return _super.call(this, {
            cardType: CardType_1.CardType.EVENT,
            name: CardName_1.CardName.DACTYL_AND_IDA,
            tags: [Tags_1.Tags.SPACE],
            cost: 18,
            metadata: {
                description: 'Raise temperature 1 step and raise oxygen 1 step. Add 2 asteroid resources to ANY card.',
                cardNumber: 'L411',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.temperature(1).oxygen(1).br;
                    b.asteroids(2).asterix();
                }),
            },
        }) || this;
    }
    DactylAndIda.prototype.canPlay = function (player) {
        var temperatureMaxed = player.game.getTemperature() < constants_1.MAX_TEMPERATURE ? 1 : 0;
        var oxygenMaxed = player.game.getTemperature() < constants_1.MAX_OXYGEN_LEVEL ? 1 : 0;
        var totalSteps = temperatureMaxed + oxygenMaxed;
        if (PartyHooks_1.PartyHooks.shouldApplyPolicy(player.game, PartyName_1.PartyName.REDS)) {
            return player.canAfford(player.getCardCost(this) + totalSteps * constants_1.REDS_RULING_POLICY_COST, { titanium: true });
        }
        return true;
    };
    DactylAndIda.prototype.play = function (player) {
        player.game.increaseTemperature(player, 1);
        player.game.increaseOxygenLevel(player, 1);
        var asteroidCards = player.getResourceCards(ResourceType_1.ResourceType.ASTEROID);
        if (asteroidCards.length === 0)
            return undefined;
        var addAsteroids = new SelectCard_1.SelectCard('Select card to add 2 asteroids', 'Add asteroids', asteroidCards, function (foundCards) {
            player.addResourceTo(foundCards[0], { qty: 2, log: true });
            return undefined;
        });
        if (asteroidCards.length === 1) {
            player.addResourceTo(asteroidCards[0], { qty: 2, log: true });
            return undefined;
        }
        else {
            return addAsteroids;
        }
    };
    return DactylAndIda;
}(Card_1.Card));
exports.DactylAndIda = DactylAndIda;
//# sourceMappingURL=DactylAndIda.js.map